import { getHotelDistances } from '@/utils/helpers'

export default {
  data () {
    return {
      sort: {
        transKey: 'online.sortOrder.',
        options: [
          'category',
          'price',
          'averageRating',
          'trainStation',
          'airport',
          'location'
        ],
        selected: null
      }
    }
  },

  methods: {
    updateSort (selected) {
      this.sort.selected = selected
      this.$refs.sortDropDown.visible = false
      this.search()
    },

    parseOffers (listHotels) {
      // Usefull for client side sorting
      listHotels.forEach(function (item, index, arr) {
        let distances = getHotelDistances(item.hotel.distances)

        for (let distance of distances) {
          item[distance.key] = distance.distance
        }

        item.distance = getHotelDistances(item.hotel.distances)
      })
    }
  },

  computed: {
    sortTitle () {
      return this.sort.selected
        ? this.$t(this.sort.transKey + this.sort.selected)
        : this.$t('_sort')
    }
  }
}
